import React from 'react';
import { Zap, Activity } from 'lucide-react';

export default function ControlPanel({
  balance, betAmount, setBetAmount, difficulty, setDifficulty, handleSpin, isSpinning
}) {
  const difficulties = ['Easy', 'Medium', 'Hard'];

  return (
    <div className="mt-4 bg-slate-950/50 p-4 rounded-2xl border border-slate-800 backdrop-blur-sm">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">

        {/* Left: Configuration */}
        <div className="space-y-3">

          {/* Bet Slider */}
          <div>
            <div className="flex justify-between text-[10px] text-cyan-400 uppercase font-bold mb-1 tracking-widest">
              <span>Wager Input</span>
              <span className="text-white">${betAmount}</span>
            </div>
            <input
              type="range"
              min="10"
              max="50000"
              step="10"
              value={betAmount}
              onChange={(e) => setBetAmount(Number(e.target.value))}
              disabled={isSpinning}
              className="w-full h-2 bg-slate-700 rounded-lg appearance-none cursor-pointer accent-cyan-500 hover:accent-cyan-400 transition-all"
            />
          </div>

          {/* Difficulty Toggles */}
          <div className="flex gap-1 bg-slate-900 p-1 rounded-lg border border-slate-700">
            {difficulties.map((level) => (
              <button
                key={level}
                onClick={() => setDifficulty(level)}
                disabled={isSpinning}
                className={`flex-1 py-2 text-[10px] font-bold uppercase rounded transition-all ${difficulty === level
                    ? 'bg-cyan-600 text-white shadow-[0_0_10px_rgba(8,145,178,0.4)]'
                    : 'text-slate-500 hover:text-slate-300'
                  }`}
              >
                {level}
              </button>
            ))}
          </div>
        </div>

        {/* Right: Spin Button */}
        <div>
          <button
            onClick={handleSpin}
            disabled={isSpinning}
            className={`group relative w-full h-20 overflow-hidden rounded-xl font-black uppercase tracking-[0.2em] text-xl transition-all 
              ${isSpinning
                ? 'bg-slate-800 text-slate-600 cursor-not-allowed border border-slate-700'
                : 'bg-gradient-to-br from-cyan-600 to-blue-700 text-white shadow-[0_0_20px_rgba(8,145,178,0.4)] hover:shadow-[0_0_30px_rgba(8,145,178,0.6)] hover:scale-[1.02] border border-cyan-500/50'
              }`}
          >
            {/* Animated background glow */}
            {!isSpinning && <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:animate-[shimmer_1s_infinite]"></div>}

            <span className="relative flex items-center justify-center gap-2">
              {isSpinning ? (
                <>
                  <Activity className="animate-spin" /> PROCESSING...
                </>
              ) : (
                <>
                  <Zap className="fill-white" /> SPIN TO WIN
                </>
              )}
            </span>
          </button>

          <div className="text-center mt-2 text-[9px] text-slate-500 uppercase tracking-widest">
            {difficulty === 'Easy' ? 'Safe Mode (1.5x)' : difficulty === 'Medium' ? 'Standard (3x)' : 'High Risk (5x)'}
          </div>
        </div>

      </div>
    </div>
  );
}